import React from 'react'

export default function CancelIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path d="M5.9 15.5H10.1C13.6 15.5 15 14.1 15 10.6V6.4C15 2.9 13.6 1.5 10.1 1.5H5.9C2.4 1.5 1 2.9 1 6.4V10.6C1 14.1 2.4 15.5 5.9 15.5Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round"/>
    <path d="M5.90047 10.8667H9.34445C10.5345 10.8667 11.5005 9.90068 11.5005 8.71068C11.5005 7.52068 10.5345 6.55469 9.34445 6.55469H4.60547" stroke="black" strokeWidth="1.5" stroke-miterlimit="10" strokeLinecap="round" stroke-linejoin="round"/>
    <path d="M5.599 7.63858L4.5 6.53259L5.599 5.43359" stroke="black" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round"/>
    </svg>
  )
}
